<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="60" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label="游戏">
          <el-select v-model="gameId" filterable clearable placeholder="全部" @change="sendEvent">
            <el-option v-for="label in POPULAR_GAMES" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="游戏组">
          <el-select
            v-model="gameGroupId"
            :popper-append-to-body="false"
            clearable
            collapse-tags
            filterable
            placeholder="全部"
            @change="sendEvent"
          >
            <el-option v-for="opt in GAME_GROUPS" :key="opt.id" :label="opt.name" :value="opt.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="项目组">
          <el-select v-model="projectGroupId" filterable clearable placeholder="全部" @change="sendEvent">
            <el-option v-for="label in PROJECT_GROUP" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="上传时间">
          <top-datepick v-model="dateType" :default="topDefault" @on-select="sendEvent" />
        </ElFormItem>

        <ElFormItem label-width="0" class="bg-transparent">
          <ElButton type="primary" @click="$emit('on-down')">数据导出</ElButton>
          <ElButton v-if="authAsynBtn" :loading="asyning" @click="$emit('on-refresh')">同步数据</ElButton>
          <ElButton @click="$emit('on-custom')">自定义列</ElButton>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { isArray } from '@/common/js/utils'
import TopDatepick from '@/views/material/ranking/components/top-datepick'
import { initPageData, PROJECT_GROUP, GAME_GROUPS, POPULAR_GAMES } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([PROJECT_GROUP, GAME_GROUPS, POPULAR_GAMES])

export default {
  name: 'StaffFilter',
  components: { TopDatepick },
  props: {
    asyning: {
      type: Boolean
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    authAsynBtn() {
      return isArray(this.access) && this.access.includes('M20798')
    }
  },
  data() {
    return {
      topDefault: moment().subtract(1, 'days').format('YYYY-MM-DD'),
      dateType: 1,
      beginTime: '',
      gameId: '',
      gameGroupId: '',
      projectGroupId: '',
      access: this.$store.state.accessAuth
    }
  },
  methods: {
    sendEvent(val) {
      if (val) {
        if (this.dateType === 3) this.beginTime = moment(val).format('YYYY-MM-01')
        else if (this.dateType === 2) this.beginTime = moment(val).startOf('week').format('YYYY-MM-DD')
        else this.beginTime = moment(val).format('YYYY-MM-DD')
      }
      this.$emit('on-change', {
        dateType: this.dateType,
        beginTime: this.beginTime,
        gameId: this.gameId === '' ? undefined : this.gameId,
        gameGroupId: this.gameGroupId === '' ? undefined : this.gameGroupId,
        projectGroupId: this.projectGroupId === '' ? undefined : this.projectGroupId
      })
    }
  }
}
</script>
